import { Directive, forwardRef, inject } from "@angular/core";
import { type AbstractControl, NG_VALIDATORS, type ValidationErrors, type Validator } from "@angular/forms";
import { CurrencyService } from "../currency.service";

@Directive({
  selector: "input[currencyValidator][ngModel]",
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => CurrencyValidatorDirective), multi: true }],
})
export class CurrencyValidatorDirective implements Validator {
  private readonly currencyService = inject(CurrencyService);

  public validate(control: AbstractControl): ValidationErrors | null {
    return this.currencyService.parseValue(control.value ?? "").isValid
      ? null
      : { invalidAmount: true };
  }
}
